import { c as _typeof } from './_rollupPluginBabelHelpers-e9b6deea.js';

var objProto = Object.prototype;
var owns = objProto.hasOwnProperty;
var toStr = objProto.toString;
var symbolValueOf;

if (typeof Symbol === 'function') {
  symbolValueOf = Symbol.prototype.valueOf;
}

var bigIntValueOf;

if (typeof BigInt === 'function') {
  // eslint-disable-next-line no-undef
  bigIntValueOf = BigInt.prototype.valueOf;
}

var isActualNaN = function isActualNaN(value) {
  return value !== value;
};

var NON_HOST_TYPES = {
  'boolean': 1,
  number: 1,
  string: 1,
  undefined: 1
};
var base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
var hexRegex = /^[A-Fa-f0-9]+$/;
/** is 判断各种数据类型 */

var is = {
  a: function a(value, type) {
    return _typeof(value) === type;
  },
  type: function type(value, _type) {
    return _typeof(value) === _type;
  },
  getType: function getType(value) {
    var dataType = toStr.call(value);
    var regRes = dataType.match(/\[object (\w+)\]/);

    if (regRes) {
      return regRes[1].toLowerCase();
    }

    throw Error("\u672A\u83B7\u53D6\u5230\u8BE5\u6570\u636E\u3010".concat(JSON.stringify(value), "\u3011\u7684\u7C7B\u578B"));
  },
  defined: function defined(value) {
    return typeof value !== 'undefined';
  },
  empty: function empty(value) {
    var type = toStr.call(value);
    var key;

    if (type === '[object Array]' || type === '[object Arguments]' || type === '[object String]') {
      return value.length === 0;
    }

    if (type === '[object Object]') {
      for (key in value) {
        if (owns.call(value, key)) {
          return false;
        }
      }

      return true;
    }

    return !value;
  },
  empty2: function empty2(value) {
    return is.nil(value) || is.undef(value) || value === '';
  },
  emptyObj: function emptyObj(value) {
    if (!is.object(value)) {
      return false;
    } else {
      return is.empty(value);
    }
  },
  equal: function equal(value, other) {
    if (value === other) {
      return true;
    }

    var type = toStr.call(value);
    var key;

    if (type !== toStr.call(other)) {
      return false;
    }

    if (type === '[object Object]') {
      for (key in value) {
        if (!is.equal(value[key], other[key]) || !(key in other)) {
          return false;
        }
      }

      for (key in other) {
        if (!is.equal(value[key], other[key]) || !(key in value)) {
          return false;
        }
      }

      return true;
    }

    if (type === '[object Array]') {
      key = value.length;

      if (key !== other.length) {
        return false;
      }

      while (key--) {
        // @ts-ignore
        if (!is.equal(value[key], other[key])) {
          return false;
        }
      }

      return true;
    }

    if (type === '[object Function]') {
      return value.prototype === other.prototype;
    }

    if (type === '[object Date]') {
      return value.getTime() === other.getTime();
    }

    return false;
  },
  hosted: function hosted(value, host) {
    var type = _typeof(host[value]);

    return type === 'object' ? !!host[value] : !NON_HOST_TYPES[type];
  },
  instance: function instance(value, constructor) {
    return value instanceof constructor;
  },
  nil: function nil(value) {
    return value === null;
  },
  undef: function undef(value) {
    return typeof value === 'undefined';
  },
  args: function args(value) {
    var isStandardArguments = toStr.call(value) === '[object Arguments]';
    var isOldArguments = !is.array(value) && is.arraylike(value) && is.object(value) && is.fn(value.callee);
    return isStandardArguments || isOldArguments;
  },
  'args-empty': function argsEmpty(value) {
    return is.args(value) && value.length === 0;
  },
  array: Array.isArray || function (value) {
    return toStr.call(value) === '[object Array]';
  },
  'array-empty': function arrayEmpty(value) {
    return is.array(value) && value.length === 0;
  },
  arraylike: function arraylike(value) {
    return !!value && !is.bool(value) && owns.call(value, 'length') && isFinite(value.length) && is.number(value.length) && value.length >= 0;
  },
  bool: function bool(value) {
    return toStr.call(value) === '[object Boolean]';
  },
  date: function date(value) {
    return toStr.call(value) === '[object Date]';
  },
  'date-valid': function dateValid(value) {
    return is.date(value) && !isNaN(Number(value));
  },
  element: function element(value) {
    return value !== undefined && typeof HTMLElement !== 'undefined' && value instanceof HTMLElement && value.nodeType === 1;
  },
  error: function error(value) {
    return toStr.call(value) === '[object Error]';
  },
  fn: function fn(value) {
    var isAlert = typeof window !== 'undefined' && value === window.alert;

    if (isAlert) {
      return true;
    }

    var str = toStr.call(value);
    return str === '[object Function]' || str === '[object GeneratorFunction]' || str === '[object AsyncFunction]';
  },
  number: function number(value) {
    return toStr.call(value) === '[object Number]';
  },
  infinite: function infinite(value) {
    return value === Infinity || value === -Infinity;
  },
  decimal: function decimal(value) {
    return is.number(value) && !isActualNaN(value) && !is.infinite(value) && value % 1 !== 0;
  },
  divisibleBy: function divisibleBy(value, n) {
    var isDividendInfinite = is.infinite(value);
    var isDivisorInfinite = is.infinite(n);
    var isNonZeroNumber = is.number(value) && !isActualNaN(value) && is.number(n) && !isActualNaN(n) && n !== 0;
    return isDividendInfinite || isDivisorInfinite || isNonZeroNumber && value % n === 0;
  },
  integer: function integer(value) {
    return is.number(value) && !isActualNaN(value) && value % 1 === 0;
  },
  maximum: function maximum(value, others) {
    if (isActualNaN(value)) {
      throw new TypeError('NaN is not a valid value');
    } else if (!is.arraylike(others)) {
      throw new TypeError('second argument must be array-like');
    }

    var len = others.length;

    while (--len >= 0) {
      if (value < others[len]) {
        return false;
      }
    }

    return true;
  },
  minimum: function minimum(value, others) {
    if (isActualNaN(value)) {
      throw new TypeError('NaN is not a valid value');
    } else if (!is.arraylike(others)) {
      throw new TypeError('second argument must be array-like');
    }

    var len = others.length;

    while (--len >= 0) {
      if (value > others[len]) {
        return false;
      }
    }

    return true;
  },
  nan: function nan(value) {
    return !is.number(value) || value !== value;
  },
  even: function even(value) {
    return is.infinite(value) || is.number(value) && value === value && value % 2 === 0;
  },
  odd: function odd(value) {
    return is.infinite(value) || is.number(value) && value === value && value % 2 !== 0;
  },
  ge: function ge(value, other) {
    if (isActualNaN(value) || isActualNaN(other)) {
      throw new TypeError('NaN is not a valid value');
    }

    return !is.infinite(value) && !is.infinite(other) && value >= other;
  },
  gt: function gt(value, other) {
    if (isActualNaN(value) || isActualNaN(other)) {
      throw new TypeError('NaN is not a valid value');
    }

    return !is.infinite(value) && !is.infinite(other) && value > other;
  },
  le: function le(value, other) {
    if (isActualNaN(value) || isActualNaN(other)) {
      throw new TypeError('NaN is not a valid value');
    }

    return !is.infinite(value) && !is.infinite(other) && value <= other;
  },
  lt: function lt(value, other) {
    if (isActualNaN(value) || isActualNaN(other)) {
      throw new TypeError('NaN is not a valid value');
    }

    return !is.infinite(value) && !is.infinite(other) && value < other;
  },
  within: function within(value, start, finish) {
    if (isActualNaN(value) || isActualNaN(start) || isActualNaN(finish)) {
      throw new TypeError('NaN is not a valid value');
    } else if (!is.number(value) || !is.number(start) || !is.number(finish)) {
      throw new TypeError('all arguments must be numbers');
    }

    var isAnyInfinite = is.infinite(value) || is.infinite(start) || is.infinite(finish);
    return isAnyInfinite || value >= start && value <= finish;
  },
  object: function object(value) {
    return toStr.call(value) === '[object Object]';
  },
  primitive: function primitive(value) {
    if (!value) {
      return true;
    }

    if (_typeof(value) === 'object' || is.object(value) || is.fn(value) || is.array(value)) {
      return false;
    }

    return true;
  },
  hash: function hash(value) {
    return is.object(value) && value.constructor === Object && !value.nodeType && !value.setInterval;
  },
  regexp: function regexp(value) {
    return toStr.call(value) === '[object RegExp]';
  },
  string: function string(value) {
    return toStr.call(value) === '[object String]';
  },
  base64: function base64(value) {
    return is.string(value) && (!value.length || base64Regex.test(value));
  },
  hex: function hex(value) {
    return is.string(value) && (!value.length || hexRegex.test(value));
  },
  symbol: function symbol(value) {
    return typeof Symbol === 'function' && toStr.call(value) === '[object Symbol]' && _typeof(symbolValueOf.call(value)) === 'symbol';
  },
  // eslint-disable-next-line valid-typeof
  bigint: function bigint(value) {
    return typeof BigInt === 'function' && toStr.call(value) === '[object BigInt]' && typeof bigIntValueOf.call(value) === 'bigint';
  }
};

export default is;
